//import { adjectives, animals, uniqueNamesGenerator } from "unique-names-generator";

import { LayoutLocator, SortablePayload } from "./types";

export const getInitials = (name: string) => {
  // eslint-disable-next-line unicorn/better-regex
  const regex = new RegExp(/(\p{L}{1})\p{L}+/gu);
  const initials = [...name.matchAll(regex)];

  return ((initials.shift()?.[1] ?? "") + (initials.pop()?.[1] ?? "")).toUpperCase();
};

export const isUrl = (string: string | null | undefined) => {
  if (!string) return false;

  const urlRegex = /https?:\/\/[^\n ]+/i;

  return urlRegex.test(string);
};

export const isEmptyString = (string: string) => {
  if (string === "<p></p>") return true;
  return string.trim().length === 0;
};

export const extractUrl = (string: string) => {
  const urlRegex = /https?:\/\/[^\n ]+/i;

  const result = urlRegex.exec(string);
  return result ? result[0] : null;
};

export const kebabCase = (string?: string | null) => {
  if (!string) return "";

  // 生成6位随机字母数字
  const randomStr = Math.random().toString(36).slice(2, 8);
  return randomStr;
};

export const generateRandomName = () => {
  // 动漫角色名
  const names = [
    "鸣人",
    "路飞",
    "悟空",
    "柯南",
    "灰原哀",
    "樱木花道",
    "亚历克斯",
    "多啦A梦",
    "皮卡丘",
    "月野兔",
  ];

  // 互联网职位
  const positions = [
    "前端工程师",
    "后端工程师",
    "全栈工程师",
    "产品经理",
    "UI设计师",
    "运维工程师",
    "数据分析师",
    "测试工程师",
    "Android工程师",
    "iOS工程师",
  ];

  // 工作年限
  const years = ["1年", "2年", "3年", "4年", "5年", "6年", "7年", "8年", "9年", "10年"];

  // 随机选择
  const randomName = names[Math.floor(Math.random() * names.length)];
  const randomPosition = positions[Math.floor(Math.random() * positions.length)];
  const randomYear = years[Math.floor(Math.random() * years.length)];

  // 返回格式化的字符串
  return `${randomName}-${randomPosition}-${randomYear}经验`;
};

export const processUsername = (string?: string | null) => {
  if (!string) return "";

  return string.replace(/[^\w.-]/g, "").toLowerCase();
};

export const parseLayoutLocator = (payload: SortablePayload | null): LayoutLocator => {
  if (!payload) return { page: 0, column: 0, section: 0 };

  const section = payload.index;
  const [page, column] = payload.containerId.split(".").map(Number);

  return { page, column, section };
};

export const generateRandomUsername = (): string => {
  const characters = "abcdefghijklmnopqrstuvwxyz";
  let result = "";
  for (let i = 0; i < 8; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  console.log(`[generateRandomUsername] 生成随机用户名: ${result}`);
  return result;
};

export const slugify = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\s\w-]/g, "") // 移除特殊字符
    .replace(/\s+/g, "-") // 空格替换为连字符
    .replace(/-+/g, "-"); // 移除重复的连字符
};
